import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const listAddresses = () => {
    return api.get(ENDPOINTS.ADDRESSES.LIST);
};

export const createAddress = (data) => {
    return api.post(ENDPOINTS.ADDRESSES.CREATE, data);
};

export const updateAddress = (id, data) => {
    return api.put(ENDPOINTS.ADDRESSES.UPDATE(id), data);
};

export const deleteAddress = (id) => {
    return api.delete(ENDPOINTS.ADDRESSES.DELETE(id));
};

export const setDefaultAddress = (id) => {
    return api.put(ENDPOINTS.ADDRESSES.SET_DEFAULT(id));
};
